import { render } from "./SlideLayers.vue?vue&type=template&id=b6a6fd84"
import script from "./SlideLayers.vue?vue&type=script&lang=js"
export * from "./SlideLayers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__